var _style, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0E0E21;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#2AE7A8;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 48,
    cy: 48,
    r: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.8,59.2l-5.7-9.7c-0.2-0.4-0.7-0.5-1-0.2l-3.7,2.4c-0.3,0.2-0.4,0.7-0.2,1l3.3,5.5c0.1,0.2,0,0.4-0.1,0.5 L48.2,71.1c-0.1,0.1-0.3,0.1-0.4,0l-19-12.4c-0.2-0.1-0.2-0.3-0.1-0.5l3.3-5.5c0.2-0.3,0.1-0.8-0.2-1l-3.7-2.4 c-0.4-0.2-0.8-0.1-1,0.2l-5.7,9.7c-0.4,0.7-0.2,1.6,0.5,2l25.5,16.6c0.5,0.3,1.1,0.3,1.6,0l25.5-16.6C75,60.7,75.2,59.8,74.8,59.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.9,44.1l3.7,2.4c0.4,0.2,0.8,0.1,1-0.2l12-20.4c0.1-0.2,0.5-0.2,0.6,0l12,20.4c0.2,0.4,0.7,0.5,1,0.2 l3.7-2.4c0.3-0.2,0.4-0.7,0.2-1L51,18.7c-0.3-0.5-0.7-0.7-1.3-0.7h-3.4c-0.5,0-1,0.3-1.3,0.7L30.7,43.1 C30.5,43.4,30.6,43.9,30.9,44.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRep);
export default __webpack_public_path__ + "static/media/REP.2193f446c527164901155f0a6b71dc18.svg";
export { ForwardRef as ReactComponent };